export type BeforeAfterCategoryTabData = {
  title: string;
  beforeImageUrl?: string;
  afterImageUrl?: string;
};

export type BeforeAfterCategoryData = {
  title: string;
  tabs?: BeforeAfterCategoryTabData[];
  enableDynamicTabs?: boolean; // Disabling dynamic catergories for now
  icon?: string | React.ReactNode; // Add this line
  dynamicTabsProjectId?: string;
  dynamicTabsSpaceId?: string;
};
